(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-height-hero-swiper"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.full-height-hero-swiper--scroll-driven');
    if (!sections.length) return;

    sections.forEach(function(section) {
      var swiperEl = section.querySelector('[data-scroll-driven]');
      if (!swiperEl) return;

      function waitForSwiper(cb) {
        if (swiperEl.swiper) return cb(swiperEl.swiper);
        var attempts = 0;
        var check = setInterval(function() {
          attempts++;
          if (swiperEl.swiper) { clearInterval(check); cb(swiperEl.swiper); }
          if (attempts > 50) clearInterval(check);
        }, 100);
      }

      waitForSwiper(function(swiper) {
        if (swiper.autoplay && swiper.autoplay.stop) swiper.autoplay.stop();
        var isVisible = false;
        var ticking = false;
        var userInteracting = false;
        var resumeTimer = null;
        var lastScrollY = window.scrollY;

        function setInteracting(active) {
          userInteracting = active;
          section.classList.toggle('full-height-hero-swiper--user-interacting', active);
        }

        swiper.on('touchStart', function() {
          setInteracting(true);
          if (resumeTimer) clearTimeout(resumeTimer);
        });

        swiper.on('touchEnd', function() {
          if (resumeTimer) clearTimeout(resumeTimer);
          resumeTimer = setTimeout(function() {
            setInteracting(false);
            lastScrollY = window.scrollY;
          }, 1500);
        });

        swiper.on('slideChangeTransitionStart', function() {
          if (!userInteracting) {
            setInteracting(true);
            if (resumeTimer) clearTimeout(resumeTimer);
          }
        });

        swiper.on('slideChangeTransitionEnd', function() {
          if (resumeTimer) clearTimeout(resumeTimer);
          resumeTimer = setTimeout(function() {
            setInteracting(false);
            lastScrollY = window.scrollY;
          }, 1000);
        });

        var observer = new IntersectionObserver(function(entries) {
          isVisible = entries[0].isIntersecting;
        }, { rootMargin: '100px 0px' });
        observer.observe(section);

        // Clamp per-frame delta to tame Safari rubber-band overshoot and
        // momentum-scroll spikes that produce huge scrollY jumps.
        var MAX_DELTA = 80;

        function onScroll() {
          if (!isVisible || ticking || userInteracting) return;
          ticking = true;
          requestAnimationFrame(function() {
            var maxScrollY = (document.documentElement.scrollHeight || 0) - window.innerHeight;
            var rawScrollY = window.scrollY;
            // Ignore Safari rubber-band (negative or past-end) by clamping the
            // reference value rather than the delta — otherwise the next frame
            // sees a large rebound delta.
            var currentScrollY = Math.max(0, Math.min(rawScrollY, maxScrollY));
            var delta = currentScrollY - lastScrollY;
            lastScrollY = currentScrollY;

            if (delta === 0) { ticking = false; return; }

            // Cap delta magnitude so a single spike can't jump multiple slides.
            if (delta > MAX_DELTA) delta = MAX_DELTA;
            else if (delta < -MAX_DELTA) delta = -MAX_DELTA;

            // Apply scroll delta as horizontal translation
            // CSS transition-duration: 150ms handles the smoothing
            var currentTranslate = swiper.getTranslate();
            swiper.setTranslate(currentTranslate - delta * 1.5);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
            if (swiper.loopFix) swiper.loopFix();

            ticking = false;
          });
        }

        window.addEventListener('scroll', onScroll, { passive: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
